import React, { useEffect, useState } from "react";

import { DataCodeEnum } from "../../../../../constants/enum";
import DataContent from "../../../../../components/DataContent";

const WhatHousesInYourBirth: React.FC = () => {
  return (
    <DataContent
      code={DataCodeEnum.WHAT_HOUSE_IN_YOUR_BIRTH_CHART_MEAN}
      name="What Houses In Your Birth Chart Mean"
      fields={[
        {
          code: "name",
          name: "Name",
        },
        {
          code: "description",
          name: "Description",
        },
      ]}
    />
  );
};

export default WhatHousesInYourBirth;
